// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".quotas-for-all[data-v-3be1994e]{background-color:#fff}.quotas-table__wrap[data-v-3be1994e]{margin-top:50px;margin-left:38px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
